import React, { useRef, useMemo, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import TYPE from "../../../../../../constant/TYPE";

const Speed = () => {

  const gaugeBox = useRef();
  const gaugeArr = useRef();
  const canvas = useRef();

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const { t } = useTranslation();

  useEffect( () => {
    canvas.current.width = gaugeBox.current.offsetWidth;
    canvas.current.height = gaugeBox.current.offsetHeight;
  }, [] );

  useEffect( () => {
    const context = canvas.current.getContext( '2d' );
    const x = canvas.current.width / 2;
    const y = canvas.current.height / 2;
    const lineWidth = 8;
    const radius = x - lineWidth;
    const startAngle = 0.75 * Math.PI;
    const endAngle = 2.25 * Math.PI;
    const speed = answeringQuestions.data.explSped / 100;
    drawLine( context, x, y, radius, startAngle, endAngle, lineWidth, '#4d6f96' );
    if ( speed ) {
      drawLine( context, x, y, radius, startAngle, ( endAngle - startAngle ) * speed + startAngle, lineWidth, '#ff6e5f' );
      rotateNeedle( speed );
    }
  }, [ answeringQuestions.data.explSped ] );

  const drawLine = ( context, x, y, radius, startAngle, endAngle, lineWidth, strokeStyle ) => {
    context.beginPath();
    context.arc( x, y, radius, startAngle, endAngle );
    context.lineWidth = lineWidth;
    context.lineCap = 'round';
    context.strokeStyle = strokeStyle;
    context.stroke();
  };

  const rotateNeedle = ( speed ) => {
    let angle = 260 * speed - 130;
    if ( -65 > angle ) {
      angle += 20;
    } else if ( 0 > angle ) {
      angle += 10;
    }
    gaugeArr.current.style.transform = `rotate( ${ angle }deg )`;
  };

  const speedLabel = useMemo( () => {
    switch ( answeringQuestions.data.explSpedCd ) {
      case TYPE.ANSWERING_QUESTIONS_SPEED.SLOW :
        return t( 'LC_05_20.msg005' );
      case TYPE.ANSWERING_QUESTIONS_SPEED.NORMAL :
        return t( 'LC_05_20.msg006' );
      case TYPE.ANSWERING_QUESTIONS_SPEED.FAST :
        return t( 'LC_05_20.msg007' );
      default :
        return <Fragment>&nbsp;</Fragment>;
    }
  }, [ answeringQuestions.data.explSpedCd ] );

  return (
    <div className="asv-wrap lr-asv-wrap">
      <div className="speedometer-wrap">
        <div className="speedometerBox">
          <div className="gaugeBox" ref={ gaugeBox }>
            <canvas ref={ canvas } />
            <div className="gaugeArr" ref={ gaugeArr } />
            <div className="txtBox">
              <p className="tit">{ t( 'LC_05_20.msg004' ) }</p>
              <p className="txt">{ speedLabel }</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Speed;
